import { Select } from "@msuite/ui/form";
import { useTranslation } from "@msuite/ui/localization";
import type { ProtocolFormSchema } from "@msuite/utils/schemas";
import { getFullName } from "@msuite/utils/users";
import { useFormContext } from "react-hook-form";
import { UserCard } from "@/components/cards";
import { useMembers } from "@/hooks/use-members";

export function ProtocolFormTypeCallRequestCallFor() {
	/** Hooks */
	const methods = useFormContext<ProtocolFormSchema>();
	const { members } = useMembers();
	const { t } = useTranslation();

	/** Render */
	return (
		<Select
			options={
				members?.map((member) => ({
					label: getFullName(member.user),
					value: member.id,
					item: {
						member,
					},
				})) || []
			}
			renderOption={(option) =>
				option.member ? (
					<UserCard
						variant="plain"
						user={option?.member?.user}
						userId={option?.member?.id}
					/>
				) : (
					<p />
				)
			}
			isRequired
			isNullable={false}
			middleware={() => {
				methods.setValue("callRequestDetails.callRequestForIdSendNotification", true);
			}}
			control={methods.control}
			name="callRequestDetails.callRequestForId"
			label={t("protocols.call_request_for_user")}
			itemNotFoundLabel={t("general.not_found")}
		/>
	);
}
